// extracted by mini-css-extract-plugin
module.exports = {"menu":"_103a151b99--menu--s19UA","item":"_103a151b99--item--JIeWb","item__red":"_103a151b99--item__red--urbv5"};